import { getPageVariationKV, getPageNameKV } from "@/common/functions";

/** Ads Inventory */
import {
    mobile_homepage_anchor,
    desktop_sentence_home_banner,
    mobile_sentence_home_anchor,
    desktop_sentence_home_topright,
    mobile_sentence_home_incontent_top,
    desktop_sentence_index_banner,
    mobile_sentence_index_anchor,
    desktop_sentence_detail_banner,
    mobile_sentence_detail_anchor,
    desktop_sentence_detail_topright,
    mobile_sentence_detail_incontent_top,
    desktop_sentence_detail_btf,
    mobile_sentence_detail_incontent_middle,
    desktop_sentence_detail_sticky,
    desktop_sentence_detail_native,
    desktop_thesaurus_home_banner,
    mobile_thesaurus_home_anchor,
    desktop_thesaurus_home_topright,
    mobile_thesaurus_home_incontent_top,
    desktop_thesaurus_index_banner,
    mobile_thesaurus_index_anchor,
    desktop_thesaurus_detail_banner,
    mobile_thesaurus_detail_anchor,
    desktop_thesaurus_detail_topright,
    desktop_thesaurus_detail_btf,
    desktop_thesaurus_detail_sticky,
    mobile_thesaurus_detail_incontent_top,
    mobile_thesaurus_detail_incontent_middle,
    mobile_es_homepage_anchor,
    desktop_es_sentence_detail_banner,
    mobile_es_sentence_detail_anchor,
    desktop_es_sentence_detail_topright,
    mobile_es_sentence_detail_incontent_top,
    desktop_es_sentence_detail_btf,
    mobile_es_sentence_detail_incontent_middle,
    desktop_es_sentence_detail_sticky,
    desktop_article_detail_banner,
    mobile_article_detail_anchor,
    desktop_article_detail_topright,
    mobile_article_detail_incontent_top,
    desktop_article_detail_btf,
    mobile_article_detail_incontent_middle,
    desktop_article_detail_sticky,
    desktop_thesaurus404_banner,
    desktop_thesaurus404_topright,
    desktop_esl_detail_btf,
    desktop_esl_detail_sticky,
    mobile_thesaurus404_anchor,
    desktop_esl_detail_banner,
    desktop_esl_detail_topright,
    mobile_esl_detail_incontent_top,
    mobile_esl_detail_incontent_middle,
    mobile_esl_detail_anchor,
    desktop_reference_detail_banner,
    desktop_grammar_detail_banner,
    desktop_grammar_detail_topright,
    desktop_grammar_detail_btf
} from "@/common/adsInventory";

const slotKeyValues_variation = slot => {
    slot.setTargeting("page_variation", getPageVariationKV());
};

const slotKeyValues_name = slot => {
    slot.setTargeting("page", getPageNameKV());
};

/**
 * Get information for each of the ads from Ads Info Spreadsheet
 * @param {String} createId The import containing ad information
 * passed in as a parameter
 */
function adProperties(createId) {
    const ad_source = createId;

    function setSizeMap() {
        let sizesArray;

        if (
            ad_source.widthB !== undefined &&
            ad_source.heightB !== undefined &&
            ad_source.widthC === undefined &&
            ad_source.heightC === undefined
        ) {
            sizesArray = [
                [ad_source.widthA, ad_source.heightA],
                [ad_source.widthB, ad_source.heightB]
            ];
        } else if (ad_source.widthC !== undefined && ad_source.heightC !== undefined) {
            sizesArray = [
                [ad_source.widthA, ad_source.heightA],
                [ad_source.widthB, ad_source.heightB],
                [ad_source.widthC, ad_source.heightC]
            ];
        } else {
            sizesArray = [[ad_source.widthA, ad_source.heightA]];
        }

        let availableSizes;

        if (
            ad_source.adUnitName === "YD_ES_Homepage_Anchor" ||
            ad_source.adUnitName === "YD_Homepage_Anchor"
        ) {
            availableSizes = [
                {
                    viewport: [ad_source.widthA, 1],
                    sizes: sizesArray
                },
                {
                    viewport: [729, 1],
                    sizes: []
                }
            ];
        } else {
            availableSizes = [
                {
                    viewport: [ad_source.widthA, 1],
                    sizes: sizesArray
                }
            ];
        }
        return availableSizes;
    }

    function setKeyValues() {
        let gptEvents;

        if (ad_source.keyA === "page_variation" && ad_source.keyB === undefined) {
            gptEvents = {
                "gpt.defined": gpt_slot => {
                    slotKeyValues_variation(gpt_slot);
                    window.ads[ad_source.adUnitName] = gpt_slot;
                }
            };
        } else if (ad_source.keyA === "page_variation" && ad_source.keyB !== undefined) {
            gptEvents = {
                "gpt.defined": gpt_slot => {
                    slotKeyValues_variation(gpt_slot);
                    slotKeyValues_name(gpt_slot);
                    window.ads[ad_source.adUnitName] = gpt_slot;
                }
            };
        }

        return gptEvents;
    }

    const properties = {
        gpt_path: `/1004147/` + ad_source.adUnitName,
        dom_id: ad_source.adUnitName,
        size_map: setSizeMap(),
        events: setKeyValues()
    };
    return properties;
}

export const inventory = {
    /**
     * Ads coming from Google spreadsheet
     */

    /** WWW Home Page */
    Mobile_Homepage_Anchor: (() => {
        return adProperties(mobile_homepage_anchor);
    })(),
    /** End WWW Home Page */

    /** Sentence Home Page */
    Desktop_Sentence_Home_Banner: (() => {
        return adProperties(desktop_sentence_home_banner);
    })(),

    Mobile_Sentence_Home_Anchor: (() => {
        return adProperties(mobile_sentence_home_anchor);
    })(),

    Desktop_Sentence_Home_TopRight: (() => {
        return adProperties(desktop_sentence_home_topright);
    })(),

    Mobile_Sentence_Home_InContent_Top: (() => {
        return adProperties(mobile_sentence_home_incontent_top);
    })(),
    /** END Sentence Home Page */

    /** Sentence Index Page */
    Desktop_Sentence_Index_Banner: (() => {
        return adProperties(desktop_sentence_index_banner);
    })(),

    Mobile_Sentence_Index_Anchor: (() => {
        return adProperties(mobile_sentence_index_anchor);
    })(),
    /** END Sentence Index Page */

    /** Sentence Detail Page */
    Desktop_Sentence_Detail_Banner: (() => {
        return adProperties(desktop_sentence_detail_banner);
    })(),

    Mobile_Sentence_Detail_Anchor: (() => {
        return adProperties(mobile_sentence_detail_anchor);
    })(),

    Desktop_Sentence_Detail_TopRight: (() => {
        return adProperties(desktop_sentence_detail_topright);
    })(),

    Mobile_Sentence_Detail_InContent_Top: (() => {
        return adProperties(mobile_sentence_detail_incontent_top);
    })(),

    Desktop_Sentence_Detail_Btf: (() => {
        return adProperties(desktop_sentence_detail_btf);
    })(),

    Mobile_Sentence_Detail_InContent_Middle: (() => {
        return adProperties(mobile_sentence_detail_incontent_middle);
    })(),

    Desktop_Sentence_Detail_Sticky: (() => {
        return adProperties(desktop_sentence_detail_sticky);
    })(),

    Desktop_Sentence_Detail_Native: (() => {
        return adProperties(desktop_sentence_detail_native);
    })(),
    /** END Sentence Detail Page */

    /** Thesaurus Home Page */
    Desktop_Thesaurus_Home_Banner: (() => {
        return adProperties(desktop_thesaurus_home_banner);
    })(),

    Mobile_Thesaurus_Home_Anchor: (() => {
        return adProperties(mobile_thesaurus_home_anchor);
    })(),

    Desktop_Thesaurus_Home_TopRight: (() => {
        return adProperties(desktop_thesaurus_home_topright);
    })(),

    Mobile_Thesaurus_Home_InContent_Top: (() => {
        return adProperties(mobile_thesaurus_home_incontent_top);
    })(),
    /** END Thesaurus Home Page */

    /** Thesaurus Index Page */
    Desktop_Thesaurus_Index_Banner: (() => {
        return adProperties(desktop_thesaurus_index_banner);
    })(),

    Mobile_Thesaurus_Index_Anchor: (() => {
        return adProperties(mobile_thesaurus_index_anchor);
    })(),
    /** End Thesaurus Index Page */

    /** Thesaurus Detail Page */
    Desktop_Thesaurus_Detail_Banner: (() => {
        return adProperties(desktop_thesaurus_detail_banner);
    })(),

    Mobile_Thesaurus_Detail_Anchor: (() => {
        return adProperties(mobile_thesaurus_detail_anchor);
    })(),

    Desktop_Thesaurus_Detail_TopRight: (() => {
        return adProperties(desktop_thesaurus_detail_topright);
    })(),

    Mobile_Thesaurus_Detail_InContent_Top: (() => {
        return adProperties(mobile_thesaurus_detail_incontent_top);
    })(),

    Desktop_Thesaurus_Detail_Btf: (() => {
        return adProperties(desktop_thesaurus_detail_btf);
    })(),

    Mobile_Thesaurus_Detail_InContent_Middle: (() => {
        return adProperties(mobile_thesaurus_detail_incontent_middle);
    })(),

    Desktop_Thesaurus_Detail_Sticky: (() => {
        return adProperties(desktop_thesaurus_detail_sticky);
    })(),
    /** END Thesaurus Detail Page */

    /** Thesaurus No Results Page */
    Desktop_Thesaurus404_banner: (() => {
        return adProperties(desktop_thesaurus404_banner);
    })(),

    Desktop_Thesaurus404_TopRight: (() => {
        return adProperties(desktop_thesaurus404_topright);
    })(),

    Mobile_Thesaurus404_Anchor: (() => {
        return adProperties(mobile_thesaurus404_anchor);
    })(),
    /** END Thesaurus No Results Page */

    /** ES Home Page */
    Mobile_ES_Homepage_Anchor: (() => {
        return adProperties(mobile_es_homepage_anchor);
    })(),
    /** End ES Home Page */

    /** ES Sentence Detail Page Page */
    Desktop_ES_Sentence_Detail_Banner: (() => {
        return adProperties(desktop_es_sentence_detail_banner);
    })(),

    Mobile_ES_Sentence_Detail_Anchor: (() => {
        return adProperties(mobile_es_sentence_detail_anchor);
    })(),

    Desktop_ES_Sentence_Detail_Topright: (() => {
        return adProperties(desktop_es_sentence_detail_topright);
    })(),

    Mobile_ES_Sentence_Detail_InContent_Top: (() => {
        return adProperties(mobile_es_sentence_detail_incontent_top);
    })(),

    Desktop_ES_Sentence_Detail_Btf: (() => {
        return adProperties(desktop_es_sentence_detail_btf);
    })(),

    Mobile_ES_Sentence_Detail_InContent_Middle: (() => {
        return adProperties(mobile_es_sentence_detail_incontent_middle);
    })(),

    Desktop_ES_Sentence_Detail_Sticky: (() => {
        return adProperties(desktop_es_sentence_detail_sticky);
    })(),
    /** End ES Sentence Detail Page Page */

    /** Article Detail Page */
    Desktop_Article_Detail_Banner: (() => {
        return adProperties(desktop_article_detail_banner);
    })(),

    Mobile_Article_Detail_Anchor: (() => {
        return adProperties(mobile_article_detail_anchor);
    })(),

    Desktop_Article_Detail_TopRight: (() => {
        return adProperties(desktop_article_detail_topright);
    })(),

    Mobile_Article_Detail_InContent_Top: (() => {
        return adProperties(mobile_article_detail_incontent_top);
    })(),

    Desktop_Article_Detail_Btf: (() => {
        return adProperties(desktop_article_detail_btf);
    })(),

    Mobile_Article_Detail_InContent_Middle: (() => {
        return adProperties(mobile_article_detail_incontent_middle);
    })(),

    Desktop_Article_Detail_Sticky: (() => {
        return adProperties(desktop_article_detail_sticky);
    })(),
    /** End Article Detail Page */

    /** ESL Home Page */

    Desktop_ESL_Detail_Banner: (() => {
        return adProperties(desktop_esl_detail_banner);
    })(),

    Desktop_ESL_Detail_TopRight: (() => {
        return adProperties(desktop_esl_detail_topright);
    })(),

    Desktop_ESL_Detail_Btf: (() => {
        return adProperties(desktop_esl_detail_btf);
    })(),

    Desktop_ESL_Detail_Sticky: (() => {
        return adProperties(desktop_esl_detail_sticky);
    })(),

    Mobile_ESL_Detail_InContent_Top: (() => {
        return adProperties(mobile_esl_detail_incontent_top);
    })(),

    Mobile_ESL_Detail_InContent_Middle: (() => {
        return adProperties(mobile_esl_detail_incontent_middle);
    })(),

    Mobile_ESL_Detail_Anchor: (() => {
        return adProperties(mobile_esl_detail_anchor);
    })(),
    /** End ESL Home Page */

    /** Reference Home Page */
    Desktop_Reference_Detail_Banner: (() => {
        return adProperties(desktop_reference_detail_banner);
    })(),
    /** End Reference Home Page */

    /** Grammar Home Page */
    Desktop_Grammar_Detail_Banner: (() => {
        return adProperties(desktop_grammar_detail_banner);
    })(),

    Desktop_Grammar_Detail_TopRight: (() => {
        return adProperties(desktop_grammar_detail_topright);
    })(),
    
    Desktop_Grammar_Detail_Btf: (() => {
        return adProperties(desktop_grammar_detail_btf);
    })()
    /** End Grammar Home Page */
    /**
     * END Ads coming from Google spreadsheet
     */
};



// WEBPACK FOOTER //
// ./src/common/ads.js